import React from 'react'
import ReactSVG from 'react-svg'
import PropTypes from 'prop-types'

import Button from '../../../../components/button'
import RoundCheckbox from '../../../../components/form-fields/round-checkbox'
import { labels } from '../../constants'
import editIcon from '../../../../../images/pencil.svg'
import styles from '../modal-add-content-to-lists.css'

const AddToListScreen = ({
  canCreateList,
  watchlists,
  selectedIds,
  saving,
  onCreateList,
  onToggleWatchlist,
  onDone
}) => {
  return (
    <>
      {canCreateList && (
        <Button
          text={labels.createNewListButton}
          onClick={onCreateList}
          darkBGSecondary
        >
          <div className={styles.buttonTextStyle}>
            <ReactSVG
              src={editIcon}
              beforeInjection={(svg) => {
                svg.setAttribute('class', styles.icon)
              }}
            />
            {labels.createNewListButton}
          </div>
        </Button>
      )}

      <div className={styles.list}>
        {watchlists.map(watchlist => {
          const isSelected = selectedIds.includes(watchlist.id)

          return (
            <RoundCheckbox
              key={`${watchlist.listType}-${watchlist.id}`}
              className={styles.watchlistCheckbox}
              name={`watchlist-${watchlist.id}`}
              label={watchlist.name}
              checked={isSelected}
              onChange={() => onToggleWatchlist(watchlist.id)}
            />
          )
        })}
      </div>

      <Button
        className={styles.doneButton}
        disabled={saving}
        text={labels.doneButton}
        onClick={onDone}
      />
    </>
  )
}

AddToListScreen.propTypes = {
  canCreateList: PropTypes.bool.isRequired,
  watchlists: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      listType: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    })
  ).isRequired,
  selectedIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  saving: PropTypes.bool.isRequired,
  onCreateList: PropTypes.func.isRequired,
  onToggleWatchlist: PropTypes.func.isRequired,
  onDone: PropTypes.func.isRequired
}

export default AddToListScreen
